/* eslint-disable */
import { Grid } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import cn from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { compose } from 'redux';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import placeOrderStyles from './PlaceOrder.component.styles';

/**
 * PlaceOrderErrorMessage
 * @param {any} props The props
 * @returns {React.Component} The component
 */
const PlaceOrderErrorMessage = ({ message, classes }) => {
  return (
    <Grid container className={cn(classes.errorBox)}>
      <Grid item>
        <Grid container spacing={2} className={cn(classes.flexWrapNowrap)}>
          <Grid item>
            <ErrorOutlineIcon />
          </Grid>
          <Grid item>{message}</Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
PlaceOrderErrorMessage.propTypes = {
  classes: PropTypes.object.isRequired,
  message: PropTypes.object.isRequired,
};

export default compose(withStyles(themeCreateInjectableStyles(placeOrderStyles), { withTheme: true }))(PlaceOrderErrorMessage);
